import { isFunction } from './isFunction.js';

function isPromise(value) {
    return isFunction(value === null || value === void 0 ? void 0 : value.then);
}

export { isPromise };
//# sourceMappingURL=isPromise.js.map
